/* eslint-disable no-shadow */
export enum SettingsLinuxTabsKeys {
  General = 'General',
  Agents = 'Agents',
  ApiAccess = 'ApiAccess',
  Cloud = 'Cloud',
}

export enum SettingsWindowsTabsKeys {
  General = 'General',
  Agents = 'Agents',
  Cloud = 'Cloud',
  ApiAccess = 'ApiAccess',
}
